export const categories = [
  {
    id: 'hot',
    name: '热门推荐',
    slug: 'hot',
    description: '精选最受欢迎的内容，实时更新热门推荐',
    icon: 'ri-fire-line',
    color: 'primary',
  },
  {
    id: 'video',
    name: '精彩视频',
    slug: 'video',
    description: '高清流畅的视频内容，覆盖多元题材',
    icon: 'ri-vidicon-line',
    color: 'accent',
  },
  {
    id: 'live',
    name: '互动直播',
    slug: 'live',
    description: '实时互动直播，与主播零距离交流',
    icon: 'ri-live-line',
    color: 'secondary',
  },
  {
    id: 'game',
    name: '休闲游戏',
    slug: 'game',
    description: '轻松有趣的休闲游戏，随时随地畅玩',
    icon: 'ri-gamepad-line',
    color: 'primary',
  },
  {
    id: 'community',
    name: '社区互动',
    slug: 'community',
    description: '活跃的用户社区，分享精彩时刻',
    icon: 'ri-chat-smile-2-line',
    color: 'accent',
  },
  {
    id: 'music',
    name: '音乐电台',
    slug: 'music',
    description: '精选音乐内容，伴你度过美好时光',
    icon: 'ri-music-line',
    color: 'secondary',
  },
];

export const featuredArticles = [
  {
    id: 1,
    title: '2026年在线娱乐新趋势：AI驱动的个性化体验',
    excerpt: '随着人工智能技术的不断进步，在线娱乐行业正迎来一场深刻的变革。从智能推荐到虚拟互动，AI正在重新定义用户的娱乐体验。',
    category: 'hot',
    categoryName: '热门推荐',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20entertainment%20abstract%20concept%20with%20warm%20peach%20and%20coral%20gradient%20flowing%20data%20streams%2C%20futuristic%20yet%20soft%20and%20inviting%20atmosphere%2C%20clean%20minimal%20composition%20with%20glowing%20elements%2C%20editorial%20style%20photography%20with%20dreamy%20bokeh&width=800&height=500&seq=article-trend-01&orientation=landscape',
    date: '2026-08-08',
    author: '蜜桃编辑团队',
    readTime: '8分钟',
  },
  {
    id: 2,
    title: '蜜桃在线全新升级：更快、更稳、更精彩',
    excerpt: '经过技术团队数月精心打磨，蜜桃在线平台迎来重大版本更新。全新的架构设计带来极速加载体验，丰富的功能优化让每一次访问都充满惊喜。',
    category: 'hot',
    categoryName: '热门推荐',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20platform%20upgrade%20concept%20with%20warm%20peach%20and%20coral%20tones%2C%20smooth%20flowing%20geometric%20shapes%20representing%20speed%20and%20innovation%2C%20soft%20gradient%20background%20with%20subtle%20light%20rays%2C%20clean%20modern%20aesthetic&width=800&height=500&seq=article-upgrade-02&orientation=landscape',
    date: '2026-08-05',
    author: '蜜桃技术团队',
    readTime: '6分钟',
  },
  {
    id: 3,
    title: '打造安全健康的在线娱乐环境：我们的承诺',
    excerpt: '在提供丰富娱乐内容的同时，蜜桃在线始终将用户安全放在首位。从内容审核到隐私保护，我们建立了全方位安全保障体系。',
    category: 'community',
    categoryName: '社区互动',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20shield%20and%20protection%20concept%20with%20warm%20peach%20and%20soft%20coral%20colors%2C%20gentle%20protective%20geometric%20shapes%20surrounding%20a%20glowing%20core%2C%20safe%20and%20trustworthy%20atmosphere%2C%20clean%20minimal%20composition%20on%20light%20background&width=800&height=500&seq=article-safety-03&orientation=landscape',
    date: '2026-08-01',
    author: '蜜桃安全中心',
    readTime: '5分钟',
  },
];

export const allArticles = [
  ...featuredArticles,
  {
    id: 4,
    title: '移动端娱乐体验优化指南：随时随地畅享精彩',
    excerpt: '手机已经成为最主要的娱乐终端。本文分享蜜桃在线移动端的体验优化技巧，帮助你获得更流畅、更舒适的掌上娱乐体验。',
    category: 'video',
    categoryName: '精彩视频',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20abstract%20entertainment%20content%20with%20warm%20peach%20tones%2C%20soft%20ambient%20lighting%2C%20clean%20minimal%20composition%20on%20light%20cream%20background%2C%20lifestyle%20product%20photography%20style&width=800&height=500&seq=article-mobile-04&orientation=landscape',
    date: '2026-07-28',
    author: '蜜桃产品团队',
    readTime: '4分钟',
  },
  {
    id: 5,
    title: '社区达人分享：如何在平台上找到志同道合的朋友',
    excerpt: '蜜桃在线社区汇聚了来自各地的活跃用户。来看看社区达人们是如何通过平台找到志同道合的伙伴，共同分享快乐时光的。',
    category: 'community',
    categoryName: '社区互动',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20connected%20network%20of%20people%20represented%20by%20glowing%20nodes%20and%20lines%2C%20peach%20and%20coral%20color%20palette%2C%20soft%20organic%20shapes%2C%20friendly%20and%20inviting%20atmosphere%2C%20clean%20minimal%20design&width=800&height=500&seq=article-community-05&orientation=landscape',
    date: '2026-07-22',
    author: '蜜桃社区团队',
    readTime: '7分钟',
  },
  {
    id: 6,
    title: '休闲游戏推荐：放松身心的五种趣味玩法',
    excerpt: '工作学习之余，来一场轻松愉快的休闲游戏是绝佳的放松方式。我们精选了平台上的五款热门休闲游戏，总有一款适合你。',
    category: 'game',
    categoryName: '休闲游戏',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20playful%20game%20elements%20floating%20in%20warm%20peach%20and%20soft%20coral%20space%2C%20gentle%20geometric%20shapes%20and%20sparkles%2C%20joyful%20and%20relaxing%20atmosphere%2C%20clean%20minimal%20composition%20on%20light%20background&width=800&height=500&seq=article-game-06&orientation=landscape',
    date: '2026-07-18',
    author: '蜜桃游戏频道',
    readTime: '5分钟',
  },
  {
    id: 7,
    title: '音乐电台精选：周末午后必备的治愈歌单',
    excerpt: '忙碌了一周，是时候给自己一个放松的午后时光。蜜桃在线音乐频道精心整理了本周最受欢迎的歌单，让音乐治愈你的心灵。',
    category: 'music',
    categoryName: '音乐电台',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20music%20waves%20and%20notes%20flowing%20in%20warm%20peach%20gradient%20space%2C%20soft%20ambient%20atmosphere%20with%20gentle%20light%20reflections%2C%20calming%20and%20peaceful%20mood%2C%20clean%20minimal%20design%20on%20cream%20background&width=800&height=500&seq=article-music-07&orientation=landscape',
    date: '2026-07-15',
    author: '蜜桃音乐频道',
    readTime: '6分钟',
  },
  {
    id: 8,
    title: '直播新功能上线：弹幕互动2.0带来全新体验',
    excerpt: '蜜桃在线直播频道推出弹幕互动2.0系统，全新的礼物特效、升级的互动玩法，让观众与主播之间的交流更加丰富多彩。',
    category: 'live',
    categoryName: '互动直播',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dynamic%20live%20streaming%20concept%20with%20flowing%20light%20trails%20in%20warm%20peach%20and%20coral%20colors%2C%20energetic%20yet%20elegant%20visual%20composition%2C%20soft%20glowing%20elements%2C%20modern%20digital%20aesthetic%20on%20light%20background&width=800&height=500&seq=article-live-08&orientation=landscape',
    date: '2026-07-10',
    author: '蜜桃直播团队',
    readTime: '4分钟',
  },
];

export const faqs = [
  {
    question: '蜜桃在线如何保证访问速度和稳定性？',
    answer: '蜜桃在线采用全球领先的CDN加速技术和分布式服务器架构，在全国主要城市部署了超过200个加速节点。同时，我们的技术团队24小时不间断监控平台运行状态，确保用户在任何时间、任何地点都能享受到极速稳定的访问体验。',
  },
  {
    question: '如何注册蜜桃在线账号？',
    answer: '注册蜜桃在线账号非常简单快捷。您只需点击首页右上角的"注册"按钮，填写手机号码或邮箱地址，设置密码并完成验证即可。整个过程仅需一分钟，注册后即可畅享平台全部功能。',
  },
  {
    question: '蜜桃在线支持哪些设备访问？',
    answer: '蜜桃在线全面支持多种设备访问，包括PC端（Windows/Mac）、移动端（iOS/Android手机和平板）。您可以通过浏览器直接访问，也可以下载我们的移动端应用获得更佳体验。所有平台数据实时同步，无缝切换。',
  },
  {
    question: '蜜桃在线的内容更新频率如何？',
    answer: '蜜桃在线每天都有大量新鲜内容更新。我们的内容团队全天候策划和上线优质内容，确保用户每次访问都能发现新的精彩。热门频道更是保持每小时更新的频率，精彩内容永不停歇。',
  },
  {
    question: '在使用过程中遇到问题如何获取帮助？',
    answer: '我们提供多渠道的客户支持服务。您可以通过在线客服（7×24小时）、帮助中心、用户社区或发送邮件至官方客服邮箱获取帮助。我们的客服团队会在最短时间内响应您的需求，确保问题得到及时解决。',
  },
  {
    question: '蜜桃在线如何保护用户隐私和安全？',
    answer: '用户隐私和安全是蜜桃在线的首要关注点。我们采用银行级数据加密技术，严格遵守相关法律法规，建立了完善的数据保护体系。所有用户信息均经过加密存储，未经用户授权绝不会向第三方透露任何个人信息。',
  },
];

export const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速访问',
    description: '全球CDN加速节点覆盖，毫秒级响应速度，畅享无延迟的流畅体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '银行级数据加密，多重安全防护机制，全方位保障您的信息安全。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '支持PC、手机、平板全平台访问，数据实时同步，随时随地畅享精彩。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    description: '7×24小时在线客服，专业技术支持团队，随时为您排忧解难。',
  },
];